import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { CSVLink } from 'react-csv';

import Aux from '../../hoc/Auxiliary';
import ModifyPermissions from '../../components/ShowUsers/ModifyPermissions/ModifyPermissions';
import Button from '../../components/UI/Button/Button'
import ShowUsers from '../../components/ShowUsers/ShowUsers';
import ShowResources from '../../components/ShowResources/ShowResources';
import ChangeResources from '../ResourceCalendar/ChangeResources/ChangeResources';
import Scanner from './Scanner/Scanner';
import TrackingData from '../../components/TrackingData/TrackingData';
import SetOpenTime from '../../components/ShowResources/SetOpenTime';

class Staff extends Component {
    state = {
        showUsers: false,
        showScanner: true,
        showData: false,
        deleteData: false,
        showResources: false,
        modifyPermissions: false,
        changeResources: false,
        modifyPermissionsUser: {},
        showOpenTime: false
    }

    componentDidMount () {
        this.props.initResources();
        this.props.initOpenTime();
    }

    showFalse = () => {
        this.setState( { showScanner: false, showData: false, showUsers: false, showResources: false } );
    }

    showUsers = ( event ) => {
        event.preventDefault();
        this.showFalse();
        this.setState( { showUsers: true } )
        this.props.onGetUsers()
    }

    showData = ( event ) => {
        event.preventDefault();
        this.showFalse();
        this.setState( { showData: true } )
    }

    showScanner = ( event ) => {
        event.preventDefault();
        this.showFalse();
        this.setState( { showScanner: true } )
    }

    showResources = ( event ) => {
        event.preventDefault();
        this.showFalse();
        this.setState( { showResources: true } );
    }

    modifyPermissions = ( user ) => {
        this.props.initResources();
        this.setState( { modifyPermissions: true, modifyPermissionsUser: user } )
    }

    closeModify = () => {
        this.setState( { modifyPermissions: false } );
    }
    updatePermissions = ( event, permissions ) => {
        event.preventDefault();
        const updatedUser = { ...this.state.modifyPermissionsUser }
        let newPermissions = {};
        for( let key in permissions ) {
            if( permissions[ key ].elementConfig.checked ) {
                newPermissions[ key ] = permissions[ key ].label;
            }
        }
        updatedUser.data.permissions = newPermissions;
        this.props.onUpdateUser( updatedUser.data, updatedUser.id );
        this.closeModify();
    }

    updateRole = ( id, role ) => {
        const updatedUser = { ...this.props.users[ id ] };
        updatedUser.role = role;
        this.props.onUpdateUser( updatedUser, id );
        //this.setState({ showUsers: false })
    }

    updateGroup = ( id, group ) => {
        const updatedUser = { ...this.props.users[ id ] };
        updatedUser.group = group;
        this.props.onUpdateUser( updatedUser, id );
        //this.setState({ showUsers: false })
    }

    modifyResources = () => {
        this.setState( { changeResources: !this.state.changeResources } )
    }

    downloadCSV = ( event ) => {
        event.preventDefault();
        this.props.onLoadCSVData();
    }

    deleteDataToggle = ( event ) => {
        event.preventDefault();
        this.setState( { deleteData: !this.state.deleteData } );
    }

    deleteData = ( event ) => {
        event.preventDefault();
        this.setState( { deleteData: false } );
        this.props.onDeleteCSVData();
    }

    setOpenTimeToggle = () => {
        this.setState( { showOpenTime: !this.state.showOpenTime } )
    }

    render () {
        let showInfo = null;
        if( this.state.showUsers ) {
            showInfo = <ShowUsers
                authRole={this.props.role}
                updateRole={this.updateRole}
                updateGroup={this.updateGroup}
                users={this.props.users}
                modifyPermissions={this.modifyPermissions} />
        }
        if( this.state.showData ) {
            showInfo = <TrackingData
                downloadCSV={this.downloadCSV}
                deleteDataToggle={this.deleteDataToggle}
                showDeleteData={this.state.deleteData}
                deleteData={this.deleteData} />
        }
        if( this.state.showScanner ) {
            showInfo = <Scanner />
        }

        if( this.state.showResources ) {
            showInfo = <ShowResources
                setOpenTimeShowToggle={this.setOpenTimeToggle}
                modifyResources={this.modifyResources} />
        }
        let downloadData = null;
        if( this.props.dataLoaded ) {
            const checkInHeaders = [
                { label: 'Minutes Spent', key: 'minutes' },
                { label: 'Date', key: 'date' },
                { label: 'Gender', key: 'gender' },
                { label: 'Group', key: 'group' },
                { label: 'Organization', key: 'organization' },
                { label: 'Reason', key: 'reason' }
            ];
            const checkInData = [];
            console.log( this.props.checkInData );
            for( let key in this.props.checkInData ) {
                checkInData.push( { ...this.props.checkInData[ key ] } )
            }
            const k12Headers = [
                { label: 'Total Students', key: 'numStudents' },
                { label: 'Male Students', key: 'numMale' },
                { label: 'Female Students', key: 'numFemale' },
                { label: 'Other Students', key: 'numOther' },
                { label: 'Underprivileged Students', key: 'numUnderprivileged' },
                { label: 'Teachers/Chaperones', key: 'numTeachers' },
                { label: 'Returning Class', key: 'returning' },
                { label: 'Date', key: 'date' },
            ];
            const k12Data = [];
            for( let key in this.props.k12Data ) {
                k12Data.push( { ...this.props.k12Data[ key ] } )
            }
            const date = new Date().toLocaleDateString();
            downloadData = (
                <Aux>
                    <CSVLink data={checkInData} headers={checkInHeaders} filename={date + "checkIn.csv"}>Check In Data</CSVLink>
                    <CSVLink data={k12Data} headers={k12Headers} filename={date + "k12.csv"}>K-12 Data</CSVLink>
                </Aux> );
        }
        let buttons = (
            <Aux>
                <Button clicked={this.showScanner}>SCANNER</Button>
                <Button clicked={this.showUsers}>USERS</Button>
            </Aux>
        );
        if( this.props.role === 'admin' ) {
            buttons = (
                <Aux>
                    <Button clicked={this.showScanner}>SCANNER</Button>
                    <Button clicked={this.showUsers}>USERS</Button>
                    <Button clicked={this.showData}>TRACKING DATA</Button>
                    <Button clicked={this.showResources}>RESOURCE CALENDAR</Button>
                </Aux> );
        }
        return (
            <div>
                {this.state.changeResources
                    ? <ChangeResources
                        close={this.modifyResources}
                        resources={this.props.resources} />
                    : null
                }
                {this.state.showOpenTime
                    ? <SetOpenTime
                        showToggle={this.setOpenTimeToggle}
                        show={this.state.showOpenTime}
                        openTime={this.props.openTime}
                        closeTime={this.props.closeTime} />
                    : null
                }
                {this.state.modifyPermissions
                    ? <ModifyPermissions
                        resources={this.props.resources}
                        user={this.state.modifyPermissionsUser.data.permissions}
                        closeModify={this.closeModify}
                        updatePermissions={this.updatePermissions} />
                    : null}
                {buttons}
                {showInfo}
                {downloadData}
            </div>
        )

    }
}
const mapStateToProps = state => {
    return {
        users: state.auth.userList,
        role: state.auth.currentUser.role,
        resources: state.resourceCal.resources,
        dataLoaded: state.tracking.dataLoaded,
        checkInData: state.tracking.trackingData,
        k12Data: state.tracking.k12Data,
        openTime: state.resourceCal.openTime,
        closeTime: state.resourceCal.closeTime
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onGetUsers: () => dispatch( actions.getUsers() ),
        initResources: () => dispatch( actions.getResources() ),
        onUpdateUser: ( user, id ) => dispatch( actions.updateUserDatabase( user, id ) ),
        onLoadCSVData: () => dispatch( actions.loadCSVData() ),
        onDeleteCSVData: () => dispatch( actions.deleteCSVData() ),
        initOpenTime: () => dispatch( actions.getLabHours() )
    }
}


export default connect( mapStateToProps, mapDispatchToProps )( Staff );